/** `sizes` for NgOptimizedImage on explore / list cards (~1/3 grid on desktop). */
export const SPACE_CARD_IMAGE_SIZES = '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw';

/** `sizes` for the space-detail hero (~2/3 of max-w-7xl shell on lg+). */
export const SPACE_HERO_IMAGE_SIZES = '(max-width: 1024px) 100vw, 60vw';
